import React, { useEffect, useMemo, useState } from 'react';
import { useLocation } from 'react-router-dom';

const OASIS_ORIGIN = 'https://oasis.applesandpears.biz';
const DESKTOP_MARGIN = 16;
const MOBILE_MARGIN = 8;
const COLLAPSED_WIDTH = 188;
const COLLAPSED_HEIGHT = 56;
const OPEN_MAX_WIDTH = 396;
const OPEN_MAX_HEIGHT = 620;

function getFrameMetrics(open, viewportWidth, viewportHeight) {
  if (!open) {
    return {
      width: COLLAPSED_WIDTH,
      height: COLLAPSED_HEIGHT,
    };
  }

  return {
    width: Math.min(OPEN_MAX_WIDTH, Math.max(320, viewportWidth - 16)),
    height: Math.min(OPEN_MAX_HEIGHT, Math.max(360, viewportHeight - 16)),
  };
}

export default function GlobalOasisPillFrame() {
  const location = useLocation();
  const [panelOpen, setPanelOpen] = useState(false);
  const [viewport, setViewport] = useState({
    width: typeof window !== 'undefined' ? window.innerWidth : 1440,
    height: typeof window !== 'undefined' ? window.innerHeight : 900,
  });

  useEffect(() => {
    const handleResize = () => {
      setViewport({ width: window.innerWidth, height: window.innerHeight });
    };

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  useEffect(() => {
    const handleMessage = (event) => {
      if (event.origin !== OASIS_ORIGIN) return;
      if (event.data?.type !== 'oasis-pill-state') return;
      setPanelOpen(Boolean(event.data.open));
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, []);

  const iframeSrc = useMemo(() => `${OASIS_ORIGIN}/inbox?embed_mode=pill`, []);
  const isMobile = viewport.width <= 1024;
  const metrics = getFrameMetrics(panelOpen, viewport.width, viewport.height);

  if (location.pathname === '/oasis') return null;

  return (
    <div
      style={{
        position: 'fixed',
        zIndex: 1400,
        width: metrics.width,
        height: metrics.height,
        bottom: isMobile ? MOBILE_MARGIN : DESKTOP_MARGIN,
        right: isMobile ? 'auto' : DESKTOP_MARGIN,
        left: isMobile ? '50%' : 'auto',
        transform: isMobile ? 'translateX(-50%)' : 'none',
        background: 'transparent',
        overflow: 'hidden',
        border: 'none',
        pointerEvents: 'auto',
        transition: 'width 0.18s ease, height 0.18s ease',
      }}
    >
      <iframe
        src={iframeSrc}
        title="Oasis Pill"
        allow="autoplay; microphone"
        style={{
          width: '100%',
          height: '100%',
          border: 'none',
          background: 'transparent',
        }}
      />
    </div>
  );
}